// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/aggiorna-prezzi/template',
    requestBody: null,
    response: 'file xlsx'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/aggiorna-prezzi/upload',
    requestBody: '(multipart: file, societaId)',
    response: '{"success":true,"data":{"totaleRighe":"number","righeAggiornate":"number","righeScartate":"number","righeErrore":"number","logTesto":"string","fatalError":"string|null"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
